export class Strings {

    private static readonly map           = ['#', '+', ' ', '/', '\\\\'].join('');
    private static readonly UsernameRegex = new RegExp(`[${Strings.map}]`, 'g');

    private static readonly Tags        = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
    private static readonly CommentTags = /<!--[\s\S]*?-->|<\?[\s\S]*?\?>/gi;

    static isBlank(str?: string): boolean {
        if (str == null) str = '';
        return (/^\s*$/).test(str);
    }

    static capitalize(str: string): string {
        str = str == null ? '' : String(str);
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    static titleCase(str: string): string {
        return str.replace('-', ' ').replace(/\w\S*/g, txt =>
        txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    }

    static toCamelCase(name: string): string {
        return name.replace(/-(\w)/g, match => match[1].toUpperCase());
    }

    static toParams(str: string | undefined): {} {
        return (str || '')
            .split('&')
            .map(s => s.split('='))
            .reduce((acc: {[s: string]: string | boolean}, arr: Array<string>) => {
                acc[arr[0]] = arr[1] || true;
                return acc;
            }, {});
    }

    static endsWith(str: string, suffix: string) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    };

    static encodeUsername(username: string): string {
        return (username || '').replace(Strings.UsernameRegex, c => encodeURIComponent(c));
    }

    static sameUser(username: string): boolean {
        return Strings.encodeUsername(options.user.username) === username;
    }

    static removeUrlProtocol(url: string): string {
        return _.isString(url) ? url.replace(/(http:|https:)/, '') : '';
    }

    // static stripTags = (input: string | string[]): string => {
    static stripTags = (input: any): string => {
        return input ?
            (_.isArray(input) ?
                input.map(i => _.isString(i) ? i.replace(Strings.CommentTags, '') : i)
                : input.replace(Strings.CommentTags, '').replace(Strings.Tags, ''))
            : '';
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/Strings.ts